import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import { formatCurrency } from 'ddc-intl';
import SingleItem from './SingleItem';
import './styles.scss';

const MAX_PACKAGES_DISPLAY = 3;

const ListStylePackages = ({
	packages,
	locale,
	onOpenModal,
	togglePackageDetails,
	prefs
}) => {
	const labels = useLabels();
	if (!packages || packages.length === 0) {
		return null;
	}

	const displayPackages = packages.slice(0, MAX_PACKAGES_DISPLAY);
	const hasMorePackages = packages.length > MAX_PACKAGES_DISPLAY;
	const isCollapseEnabled = prefs?.toggleCollapse === 'true';
	const listStylePackagesClassName = isCollapseEnabled
		? 'list-style-packages list-style-packages-collapse-enabled'
		: 'list-style-packages';

	return (
		<div className={listStylePackagesClassName}>
			{displayPackages.map((pkg, index) => (
				<SingleItem
					key={pkg.name || index}
					index={index}
					itemName={pkg.name}
					subItems={pkg.subitems || []}
					itemType="package"
					itemPrice={
						pkg.price > 0 ? formatCurrency(pkg.price, locale) : '0'
					}
					onOpenModal={onOpenModal}
					totalItemsCount={displayPackages.length}
					isFirstItem={index === 0}
					isEnableDisclaimer={prefs?.enableDisclaimers === 'true'}
					layout={prefs?.packagesOptionsLayout || 'list'}
					togglePackageDetails={togglePackageDetails}
				/>
			))}
			{hasMorePackages && (
				<div className="see-all-container py-4 mt-6">
					<button
						type="button"
						className="btn btn-link px-0"
						onClick={onOpenModal}
					>
						{labels.get('SEE_ALL_PACKAGES_OPTIONS')}
					</button>
				</div>
			)}
		</div>
	);
};

ListStylePackages.defaultProps = {
	packages: [],
	locale: 'en_US',
	togglePackageDetails: false,
	prefs: {}
};

ListStylePackages.propTypes = {
	packages: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			price: PropTypes.number.isRequired,
			subitems: PropTypes.arrayOf(
				PropTypes.shape({
					name: PropTypes.string,
					price: PropTypes.number
				})
			).isRequired
		})
	),
	locale: PropTypes.string,
	onOpenModal: PropTypes.func.isRequired,
	togglePackageDetails: PropTypes.bool,
	prefs: PropTypes.shape({
		displayPackagesPricing: PropTypes.string,
		enableDisclaimers: PropTypes.string,
		packagesOptionsLayout: PropTypes.string,
		toggleCollapse: PropTypes.string
	})
};

export default ListStylePackages;
